import { FC, useEffect, useState } from "react";
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import { Icon } from "Components/UI";
import { Switch } from "antd";
import SpinCustom from "Components/UI/SpinCustom";
import Tooltip from "Components/UI/Tooltip";
import { copyToClipboard } from "Utils/TextUtils";
import { Mixpanel } from 'Utils/MixPanel';
import { useTimeout } from "Context/TimeoutContext";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { getUserInfo } from "Store/Auth/Auth.selector";
import { getCurrentTenant, getTenants } from "Store/Tenant/Tenant.selector";
import {
  FooterButtons,
  FooterHr,
  Header,
  InfoCard,
  LinkCard,
  LoadingWrapper,
  SwitchCard,
  Wrapper,
} from "./styles";

interface IShareLink {
  visible: boolean;
  constructionSiteId: number;
  context?: number;
  shareLink?: string;
  loading?: boolean;
  onCancel: () => void;
}

const ShareLink: FC<IShareLink> = ({
  visible,
  constructionSiteId,
  loading,
  context,
  shareLink,
  onCancel,
}) => {
  const location = useLocation();
  const { set, clear } = useTimeout();

  const userInfo = useSelector(getUserInfo);
  const currentTenant = useSelector(getCurrentTenant);
  const tenants = useSelector(getTenants);

  const [shareShortlyLink, setShareShortlyLink] = useState(false);
  const [linkCopy, setLinkCopy] = useState(false);
  
  const defaultLnk = `${window.location.origin}/construtora/${context}?redirectUrl=${encodeURIComponent(`${location.pathname}${location.search}`)}`;

  const handleCurrentShareLink = () => {
    setShareShortlyLink(!shareShortlyLink);
  }

  const handleCopyCurrentShareLink = () => {
    if (shareShortlyLink && shareLink) {
      copyToClipboard(shareLink);
      setLinkCopy(true);

    } else {
      copyToClipboard(defaultLnk);
      setLinkCopy(true);
    }

    Mixpanel.track({
      name: 'ACTIVITY_SHARE_LINK',
      props: {
        constructionSiteId: constructionSiteId,
        withFilter: !!shareShortlyLink && !!shareLink,
      },
      userInfo: userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });
  }

  useEffect(() => {
    if (shareLink) {
      setShareShortlyLink(true)
    }
  }, [shareLink]);

  useEffect(() => {
    if (linkCopy) {
      clear('ShareLink-linkCopy');
      set('ShareLink-linkCopy', () => {
        setLinkCopy(false);
      }, 1000);
    }

    return () => {
      clear('ShareLink-linkCopy');
    }
  }, [linkCopy, set, clear]);

  const footerConfirmButtons = (
    <FooterButtons>
      <Tooltip
        overlay={
          linkCopy
            ? <label style={{ color: 'green' }}>Link copiado!</label>
            : "Copiar link"
        }
        placement="top"
      >
        <Button
          onClick={handleCopyCurrentShareLink}
          className="buttonCopy"
        >
          <Icon
            icon="link"
            className="iconLink"
          />
          Copiar Link
        </Button>
      </Tooltip>
      <Button
        type="primary"
        onClick={onCancel}
        className="buttonClose"
      >
        Concluído
      </Button>
    </FooterButtons>
  );

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footerButtons={!loading ? footerConfirmButtons : null}
      footerActive={false}
      width={400}
      style={{ marginRight: '2px' }}
    >
      <Wrapper>
        <Header>
          <span className="title">
            Compartilhar lista de atividades
          </span>
          <Icon
            icon="cancelar"
            onClick={onCancel}
            className="iconClose"
            customSize={12}
          />
        </Header>
        <hr className="midleHr" />
        {!loading && (
          <>
            <span className="description">
              Compartilhe o link:
            </span>
            <LinkCard>
              <span className="shareLink">
                {shareShortlyLink ? (shareLink || '') : defaultLnk}
              </span>
              <Tooltip
                overlay={
                  linkCopy
                    ? <label style={{ color: 'green' }}>Link copiado!</label>
                    : "Copiar link"
                }
                placement="top"
              >
                <div
                  className="customButtonCopy"
                  onClick={handleCopyCurrentShareLink}
                >
                  <Icon
                    icon="copiar"
                    className="iconCopy"
                  />
                </div>
              </Tooltip>
            </LinkCard>
            {!!shareLink && (
              <SwitchCard checked={`${shareShortlyLink}`}>
                <Switch
                  size="small"
                  onChange={handleCurrentShareLink}
                  className="antdSwitch"
                  checked={shareShortlyLink}
                />
                <span className="switchText">
                  Incluir filtros que estão aplicados na listagem.
                </span>
              </SwitchCard>
            )}
            <span className="subDescription">
              Acesso ao link
            </span>
            <InfoCard>
              <span className="leftCard">
                <Icon
                  icon="cadeadoFechado"
                  className="infoIcon"
                />
              </span>
              <span className="rightCard">
                <span className="headerText">
                  Restrito à obra
                </span>
                <span className="subText">
                  Apenas os usuários da obra podem acessar usando o link.
                </span>
              </span>
            </InfoCard>
          </>
        )}
        {loading && (
          <LoadingWrapper>
            <SpinCustom size={32} />
            <span className="loadingText">
              Carregando...
            </span>
          </LoadingWrapper>
        )}
      </Wrapper>
      {!loading && <FooterHr />}
    </Modal>
  )
}

export default ShareLink;
